import { CONFIG_OCCUPATION_EXTRAS } from 'constants';

const useOccupation = () => {
  const checkShowPreviousOccupationField = (occupationKey) =>
    CONFIG_OCCUPATION_EXTRAS.includes(occupationKey);

  return { checkShowPreviousOccupationField };
};

export default useOccupation;
